import { useState, useCallback } from 'react';
import { Palette, RotateCcw } from 'lucide-react';
import { useTheme } from '../../contexts/ThemeContext';
import { themes } from '../../themes';
import { cn } from '../../lib/utils';
import Dropdown from '../ui/Dropdown';

export default function ThemeSelector() {
  const { themeId, isOverriding, availableThemes, setThemeOverride } = useTheme();
  const theme = themes[themeId];
  const [isOpen, setIsOpen] = useState(false);
  const onClose = useCallback(() => setIsOpen(false), []);

  return (
    <Dropdown
      isOpen={isOpen}
      onClose={onClose}
      width="w-48"
      trigger={
        <button
          onClick={() => setIsOpen(!isOpen)}
          className={cn(
            'flex items-center gap-1.5 px-3 py-2 rounded-lg text-sm font-medium transition-all',
            isOverriding
              ? 'bg-black/80 text-white border border-black/50'
              : theme?.headerBackground
                ? 'text-black/70 hover:text-black hover:bg-black/10'
                : 'text-white/70 hover:text-white hover:bg-white/10',
          )}
          title="Theme selector (Admin only)"
        >
          <Palette className="w-4 h-4" />
          <span className="hidden sm:inline">{theme?.name || themeId}</span>
        </button>
      }
    >
      <div className="p-2 border-b border-border">
        <p className="text-xs text-muted-foreground px-2 py-1">Theme Preview</p>
      </div>
      <div className="p-2 space-y-1">
        {availableThemes.map((tid) => (
          <button
            key={tid}
            onClick={() => {
              setThemeOverride(tid);
              setIsOpen(false);
            }}
            className={cn(
              'w-full flex items-center gap-2 px-3 py-2 text-sm rounded-lg transition-colors',
              themeId === tid
                ? 'bg-primary/20 text-primary'
                : 'text-muted-foreground hover:text-foreground hover:bg-background',
            )}
          >
            <div
              className="w-4 h-4 rounded-full border border-white/20"
              style={{ backgroundColor: `hsl(${themes[tid]?.colors.primary})` }}
            />
            {themes[tid]?.name || tid}
            {themeId === tid && <span className="ml-auto text-xs">active</span>}
          </button>
        ))}
        {isOverriding && (
          <>
            <div className="border-t border-border my-1" />
            <button
              onClick={() => {
                setThemeOverride(null);
                setIsOpen(false);
              }}
              className="w-full flex items-center gap-2 px-3 py-2 text-sm text-primary hover:bg-primary/10 rounded-lg transition-colors"
            >
              <RotateCcw className="w-4 h-4" />
              Reset to assigned
            </button>
          </>
        )}
      </div>
    </Dropdown>
  );
}
